import React, { useState }  from 'react'
import { MdEdit } from 'react-icons/md'
import { IoMdClose } from 'react-icons/io'
import PngImg from '../../images/sample.png'
export default function ABC() {
    const [ABC, setABC] = useState(false)
    const [DEF, setDEF] = useState([{
      'id':'1',
      'item':`${process.env.NODE_ENV === 'production'?`${process.env.REACT_APP_URL}${PngImg.slice(1)}`:PngImg}`,
      'filename':'sample.png',
      'filetype':'image/png',
      'filesize':'83.61KB'
    },{
      'id':'2',
      'item':`${process.env.NODE_ENV === 'production'?`${process.env.REACT_APP_URL}${PngImg.slice(1)}`:PngImg}`,
      'filename':'sample.png',
      'filetype':'image/png',
      'filesize':'83.61KB'
    }])
    const [GHI, setGHI] = useState('')
    const [PQR, setPQR] = useState(PngImg)
    const [JKL, setJKL] = useState()
    const [MNO, setMNO] = useState()
    const HIJ = (e) => {
        e.preventDefault()
        setDEF(DEF.concat({
            id:Math.random().toString(36).substring(2),
            item:URL.createObjectURL(e.target.files[0]),
            filename:e.target.files[0].name,
            filesize:e.target.files[0].size,
            filetype:e.target.files[0].type
        }))
        setABC(!ABC)
    }
    const STU = (y) => {
        setDEF((x) => x.filter((i, a) => a !== y))
        setABC(!ABC)
    }
    const VWX = (x) => {
        setGHI(x)
        if(x.item===PngImg){
          setABC(false)
          setPQR(x.item)
          setJKL(null)
          setMNO(null)
        }else{
          setABC(false)
          setPQR(x.item)
          setJKL(x.filesize)
          setMNO(x.filetype)
        }
    }
    const YZA = (e) => {
        e.preventDefault()
        setGHI({...GHI, item:URL.createObjectURL(e.target.files[0])})
        setPQR(URL.createObjectURL(e.target.files[0]))
        setJKL(e.target.files[0].size)
        setMNO(e.target.files[0].type)
        setABC(!ABC)
    }
    const BCD = (e) => {
        e.preventDefault()
        const x = DEF.filter(y => y.id === GHI.id)[0]
        const w = DEF.indexOf(x)
        var z = [...DEF]
        z[w] = {...z[w] , item:GHI.item, filesize:JKL,filetype:MNO}
        setDEF(z)
        setGHI('')
    }
    const EFG = (y) => { 
        setDEF((x) => {
        return x.filter((x) => x.id !== y)
    })
    } 
    return (
      <div className='upload-container mt-1'>
      <div className='text-left mb-1'>
      <label for='file5_1' 
      style={{padding:'5px 14px'}}
      className='secondary-btn mr-1 font-bold'>Upload Image</label>
      <input 
        id='file5_1'
        type='file' 
        accept='image/jpeg, image/jpg, image/png, image/gif'
        onChange={HIJ} 
        single
        hidden
      />
      </div>
       <div className='grid grid-cols-5 gap-1 w-full md:w-[840px]'>
        {DEF.map((x)=> (
        <>
        {GHI.id === x.id ?<div className='w-[200px] flex-col z-10 bg-white p-1 border border-black'> 
        <div className='flex mb-1'>
        <label for='file5_2' style={{padding:'2px 14px'}}
        className='secondary-btn text-xs font-bold'>Change Image</label>
        <input 
            id='file5_2'
            type='file' 
            accept='image/jpeg, image/jpg, image/png, image/gif'
            onChange={YZA} 
            single
            hidden
        />
        {ABC?<button className='plane-btn' onClick={STU}>
        <IoMdClose/></button>:''}<br/>
        </div>
        <img src={process.env.NODE_ENV === 'production'?`${process.env.REACT_APP_URL}${PQR.slice(1)}`:PQR} className='sample-img m-auto '/>
        {ABC? <>{MNO === 'image/jpeg' || MNO === 'image/png' || MNO === 'image/gif'? <div className='success-msg ml-5'>✓ jpg, png, gif file only</div>:<div className='error-msg ml-5'>x jpg, png, gif file only</div>}</>
        :''}
        {ABC? <>{JKL < 10485760? <div className='success-msg ml-5'>✓ max 10MB</div>:<div className='error-msg ml-5'>x  max 10MB({((JKL-10485760)/ (1024 * 1024)).toFixed(0)}MB exceeded)</div>}</>:''}
        <div className='m-auto text-center'><button className='plane-btn mr-2' onClick={() => setGHI('')}>cancel</button>
        <button className="plane-btn" onClick={(e) => BCD(e)}>save</button>
        </div>
        </div> :
        <div className='flex-col w-fit'>
        <div>
        <img src={x.item} className='sample-img'/>
        </div>
        {x.filename}
        <div className='flex'>
        <button className="plane-btn" onClick={()=>VWX(x)}><MdEdit /></button><button className='plane-btn' onClick={(e)=>EFG(x.id)}><IoMdClose/></button>
        </div>    
        </div>
        }
        </>
        ))}
        </div>
      </div>
    )
  }